import { API, graphqlOperation } from "aws-amplify";
import {
  CreateEmailInput,
  DeleteEmailInput,
  Email,
  ListEmailBySubjectIdQuery,
  UpdateEmailInput,
} from "types/graphqlapi";
import { listEmailBySubjectId } from "graphql/queries";
import { createEmail, deleteEmail, updateEmail } from "graphql/mutations";
import { GraphQLResult } from "@aws-amplify/api-graphql";

export const fetchEmailBySubjectIdQuery = async (subjectId: string) => {
  let list: Email[] = [];
  let nextToken = null;

  do {
    const result = (await API.graphql(
      graphqlOperation(listEmailBySubjectId, {
        subject_id: subjectId,
        limit: 100,
        nextToken,
      })
    )) as {
      data: ListEmailBySubjectIdQuery;
    };
    const data = result.data.listEmailBySubjectId;
    const items = (data?.items || []) as Email[];

    nextToken = data?.nextToken;

    list = [...list, ...items];
  } while (nextToken);

  return list;
};

export const createEmailMutation = async (
  createEmailInput: CreateEmailInput
) => {
  const result = (await API.graphql(
    graphqlOperation(createEmail, {
      input: createEmailInput,
    })
  )) as GraphQLResult<{ createEmail: Email }>;

  return result;
};

export const updateEmailMutation = async (
  updateEmailInput: UpdateEmailInput
) => {
  const result = (await API.graphql(
    graphqlOperation(updateEmail, { input: updateEmailInput })
  )) as GraphQLResult<{ updateEmail: Email }>;

  return result;
};

export const deleteEmailMutation = async (
  deleteEmailInput: DeleteEmailInput
) => {
  const result = (await API.graphql(
    graphqlOperation(deleteEmail, {
      input: deleteEmailInput,
    })
  )) as GraphQLResult<{ deleteEmail: Email }>;

  return result;
};
